export default __webpack_public_path__ + "static/media/7.f482b75d.png";